
import { Linkedin } from "lucide-react";
import { Link } from "react-router-dom";


const Footer = () => {

  return (
    <footer className="bg-black text-white pt-8 pb-8 w-full">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 pb-10 border-b border-gray-700">
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Homeowner Benefits</h3>
            <ul className="space-y-3">
              <li><Link to="/text-concierge" className="text-gray-300 hover:text-brand-blue transition-colors">Text Concierge</Link></li>
              <li><Link to="/your-monthly-beat" className="text-gray-300 hover:text-brand-blue transition-colors">Stay Organized</Link></li>
              <li><Link to="/home-improvement" className="text-gray-300 hover:text-brand-blue transition-colors">Improvements Made Easy</Link></li>
              <li><Link to="/repairs" className="text-gray-300 hover:text-brand-blue transition-colors">Help with Repairs</Link></li>
              <li><Link to="/maintenance" className="text-gray-300 hover:text-brand-blue transition-colors">Track & Manage Maintenance</Link></li>
              <li><Link to="/home-report-roadmap" className="text-gray-300 hover:text-brand-blue transition-colors">Roadmap For Your Home</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Industry Solutions</h3>
            <ul className="space-y-3">
              <li><Link to="/for-insurers" className="text-gray-300 hover:text-brand-blue transition-colors">Insurance</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">About Us</h3>
            <ul className="space-y-3">
              <li><Link to="/meet-the-founders" className="text-gray-300 hover:text-brand-blue transition-colors">Meet the Founders</Link></li>
              <li><Link to="/our-vision" className="text-gray-300 hover:text-brand-blue transition-colors">Our Home Health Vision</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-brand-blue transition-colors">The Beat Blog</Link></li>
              <li><Link to="/faq" className="text-gray-300 hover:text-brand-blue transition-colors">FAQ</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Company</h3>
            <ul className="space-y-3">
              <li><a href="https://app.housebeat.com/welcome" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-brand-blue transition-colors">Get Started</a></li>
              <li><a href="https://app.housebeat.com/signin" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-brand-blue transition-colors">Log In</a></li>
              <li><Link to="/book-demo" className="text-gray-300 hover:text-brand-blue transition-colors">Book a Demo</Link></li>
              <li><Link to="/privacy" className="text-gray-300 hover:text-brand-blue transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-gray-300 hover:text-brand-blue transition-colors">Terms of Use</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm mb-4 md:mb-0">
            Copyright 2026 Metronome Technologies Inc. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <Link to="/privacy" className="text-sm text-gray-300 hover:text-brand-blue transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-sm text-gray-300 hover:text-brand-blue transition-colors">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
